import { ListItemText } from '@mui/material';
import { Link } from 'react-router-dom';
import { DomainSidebarContainer, DomainSidebarItemButton, DomainSidebarList, DomainSidebarTitle } from './styles';
import { UPDomainSidebarProps } from './types';

const UPDomainSidebar = (props: UPDomainSidebarProps): JSX.Element => {
  const { title, items, activeKey, testIdPrefix } = props;

  return (
    <DomainSidebarContainer>
      {title && <DomainSidebarTitle>{title}</DomainSidebarTitle>}
      <DomainSidebarList disablePadding>
        {items.map(item => (
          <DomainSidebarItemButton
            key={item.key}
            component={Link}
            to={item.route}
            isActive={item.key === activeKey}
            selected={item.key === activeKey}
            title={item.label}
            data-testid={testIdPrefix ? `${testIdPrefix}-${item.key}` : undefined}
          >
            <ListItemText primary={item.label} />
          </DomainSidebarItemButton>
        ))}
      </DomainSidebarList>
    </DomainSidebarContainer>
  );
};

UPDomainSidebar.defaultProps = {
  title: undefined,
  testIdPrefix: undefined,
};

export default UPDomainSidebar;
